import React from 'react';
import { Typography, Box } from '@mui/material';

const Quality = () => {
  return (
    <Box>
      <Typography variant="h5" component="h1" gutterBottom sx={{ fontSize: '1.25rem', fontWeight: 600 }}>
        Quality
      </Typography>
      <Typography variant="body1">
        Quality control and assurance - Coming soon
      </Typography>
    </Box>
  );
};

export default Quality;
